import Vue from 'vue';
import App from './App.vue';
import store from './store';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/custom.css';
import AFTableColumn from 'af-table-column';
import ExTableColumn from 'ex-table-column';
import moment from 'moment';

import router from './router/index';
// import common from "./common/common.js";
// Vue.prototype.common = common;
Vue.use(ElementUI);
Vue.prototype.$moment = moment; // 赋值使用
Vue.filter('dateFormat', function (dateStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dateStr).format(pattern);
});

const fontRate = {
  CHAR_RATE: 1, // 汉字比率
  NUM_RATE: 0.5, // 数字
  OTHER_RATE: 0.5, // 除汉字和数字以外的字符的比率
};
const fontSize = 15;
// 注册组件
Vue.use(AFTableColumn, { fontRate, fontSize });
Vue.component(ExTableColumn.name, ExTableColumn);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
